import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Chip } from '@mui/material';

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#8e24aa", // light purple
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));



const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

// Component
export default function CustomizedTables({ columns, rows }) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700,maxHeight:"70vh" }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <StyledTableCell key={column.key} align={column.align || 'left'}>
                {column.label}
              </StyledTableCell>

            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <StyledTableRow key={idx}>
              {columns.map((column) => (
                <StyledTableCell key={column.key} align={column.align || 'left'}>
                  {column.key === 'status' ? (
                    <Chip
                      label={row[column.key]}
                      color={row[column.key].toLowerCase() === 'active' ? 'success' : 'red'}
                      variant="filled"
                      size="small"
                      sx={{ backgroundColor: row[column.key].toLowerCase() === 'active' ? 'success' : 'red',color:'white' }}
                    />
                  ) : column.key === 'sno' ? (
                    idx + 1
                  ) : (
                    row[column.key]
                  )}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
